import React, { PropsWithChildren,  useState, useEffect } from 'react'
import { usePlayerGameStatusUpdate } from '../hooks/usePlayerGameStatusUpdate'
import { PlayerInfo } from '../lib/models/PlayerInfo'
import GameInfo from '../lib/models/GameInfo'


const PlayerContext = React.createContext<[PlayerInfo, 
  {
    addScore: (score: number) => void,
    updateRound: (round: number) => void
    updateName: (name: string) => void
  }]>(undefined!)

interface PlayerContextProviderProps {
  game: GameInfo,
  playerId: string,
}



const PlayerContextProvider = ({ game, playerId, children }: PropsWithChildren<PlayerContextProviderProps>) => {
  const { players } = game;
  const playerIndex = players.findIndex(p => p.id === playerId) || 0;
  const player = players[playerIndex];
  const [playerData, setPlayerData] = useState({
    score: player.score,
    round: player.round,
    name: player.name
  })
  const [update] = usePlayerGameStatusUpdate(game.id, playerId, playerIndex + 1, playerData.name)

  const updateName = (name: string) => {
    setPlayerData({...playerData, name})
  }
  const addScore = (score: number) => {
    setPlayerData({...playerData, score: playerData.score + score})
  }
  const updateRound = (round: number) => {
    setPlayerData({...playerData, round})
  }
  useEffect(() => {
    update(playerData.score, playerData.round, playerData.name)

  }, [playerData])

  return (
    <PlayerContext.Provider value={[{
      id: playerId,
      score: playerData.score,
      round: playerData.round,
      name: playerData.name
    }, {updateName, addScore, updateRound}]}>
      {children}
    </PlayerContext.Provider>
  )
}

export {PlayerContext, PlayerContextProvider}

